import React from 'react'
import Grid from '@mui/material/Grid'
import SimpleTextField from '../../../../../components/Forms/SimpleTextField'
const Spo2 = ({ value, onChange }) => (
  <Grid item xs={12} md={6} lg={4} xl={3}>
    <SimpleTextField
      value={value}
      onChange={onChange}
      label="SPO2"
      type="number"
      InputProps={{
        endAdornment: '%',
        inputProps: { min: 1, max: 100, step: 'any' },
      }}
    />
  </Grid>
)

export default Spo2
